export function checkSession() {
  const storeDataSession = localStorage.getItem("okta-token-storage");
  const parsedStoreDataSession = parseSessionData(storeDataSession);

  if (hasSessionExpired(parsedStoreDataSession)) {
    localStorage.removeItem("okta-token-storage");
    window.location.reload();
  }
}

function parseSessionData(sessionData: any) {
  return sessionData && sessionData !== "" ? JSON.parse(sessionData) : null;
}

function hasSessionExpired(session: any) {
  return session && session.idToken?.expiresAt <= Math.floor(Date.now() / 1000);
}
